import { isEmpty } from 'validator';

const LocaleRegex =
  '^[A-Za-z]{2,4}([_-][A-Za-z]{4})?([_-]([A-Za-z]{2}|[0-9]{3}))?$';

export const pathWithoutLocale = (path: string) => {
  return path
    .split('/')
    .filter((item) => !isEmpty(item) && !item.match(LocaleRegex))
    .join('/');
};

export const localeFromPath = (path: string) => {
  return path
    .split('/')
    .find((item) => !isEmpty(item) && item.match(LocaleRegex));
};
